// MissingEmailPanel.jsx
// 📭 Jin students ne Registration No. daala aur DB me unka email nahi tha
import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const FILTERS = [
  { key: "pending",  label: "📭 Email missing" },
  { key: "resolved", label: "✅ Email added" },
  { key: "all",      label: "All" },
];

export default function MissingEmailPanel({ adminKey }) {
  const [status, setStatus]     = useState("pending");
  const [items, setItems]       = useState([]);
  const [counts, setCounts]     = useState({ pending: 0, resolved: 0, all: 0 });
  const [search, setSearch]     = useState("");
  const [loading, setLoading]   = useState(false);
  const [scanning, setScanning] = useState(false);
  const [msg, setMsg]           = useState({ ok: true, text: "" });

  const [editing, setEditing] = useState(null);
  const [form, setForm]       = useState({ email: "", phone: "" });
  const [saving, setSaving]   = useState(false);
  const [formErr, setFormErr] = useState("");

  const headers = { "Content-Type": "application/json", "x-admin-key": adminKey };

  async function load() {
    setLoading(true);
    try {
      const res  = await fetch(`${API_BASE}/admin/missing-email?status=${status}`, { headers });
      const data = await res.json();
      setItems(data.items || []);
      if (data.counts) setCounts(data.counts);
    } catch {
      setItems([]);
      setMsg({ ok: false, text: "List load nahi hui. Server check karein." });
    } finally { setLoading(false); }
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const filtered = items.filter((it) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return [it.name, it.registrationNo, it.phone, it.email, it.course]
      .some((v) => v && String(v).toLowerCase().includes(q));
  });

  async function handleScan() {
    if (!window.confirm("Poore student database me jinka email khaali hai, unko list me add karein?")) return;
    setScanning(true); setMsg({ ok: true, text: "" });
    try {
      const res  = await fetch(`${API_BASE}/admin/missing-email/scan`, { method: "POST", headers });
      const data = await res.json();
      setMsg({ ok: !!data.success, text: data.message || "Scan done." });
      load();
    } catch {
      setMsg({ ok: false, text: "Scan nahi hua. Dobara try karein." });
    } finally { setScanning(false); }
  }

  function openEdit(it) {
    setEditing(it);
    setForm({ email: it.email || "", phone: it.phone || "" });
    setFormErr("");
  }

  async function handleSave() {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      setFormErr("Sahi email address daalein.");
      return;
    }
    setSaving(true); setFormErr("");
    try {
      const res  = await fetch(`${API_BASE}/admin/missing-email/${editing._id}`, {
        method: "PUT", headers,
        body: JSON.stringify({ email: form.email.trim(), phone: form.phone.trim() }),
      });
      const data = await res.json();
      if (!data.success) { setFormErr(data.message || "Save nahi hua."); return; }
      setMsg({ ok: true, text: data.message });
      setEditing(null);
      load();
    } catch {
      setFormErr("Server se connect nahi ho pa raha.");
    } finally { setSaving(false); }
  }

  async function handleRemove(it) {
    if (!window.confirm(`${it.name || it.registrationNo} ko is list se hatana hai?\n(Student ka record delete nahi hoga)`)) return;
    try {
      const res  = await fetch(`${API_BASE}/admin/missing-email/${it._id}`, { method: "DELETE", headers });
      const data = await res.json();
      setMsg({ ok: !!data.success, text: data.message || "Removed." });
      load();
    } catch {
      setMsg({ ok: false, text: "Remove nahi hua." });
    }
  }

  function exportCsv() {
    const cols = ["Name", "Registration No", "Phone", "Course", "Attempts", "Last Attempt", "Status", "Email"];
    const esc  = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const rows = filtered.map((it) => [
      it.name, it.registrationNo, it.phone, it.course, it.attempts || 0,
      it.lastAttemptAt ? formatDate(it.lastAttemptAt) : "",
      it.status, it.email || "",
    ].map(esc).join(","));
    const blob = new Blob([[cols.join(","), ...rows].join("\n")], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `missing-email-${status}-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  }

  return (
    <div>
      <p style={s.intro}>
        Ye wo students hain jinhone <b>Registration No.</b> se login kiya aur database me unka
        email nahi tha. Student khud email save kar de to entry apne aap "Email added" me chali jaati hai.
      </p>

      {msg.text && (
        <div style={{ ...s.banner, ...(msg.ok ? s.bannerOk : s.bannerErr) }}>
          {msg.ok ? "✅" : "❌"} {msg.text}
          <button style={s.bannerClose} onClick={() => setMsg({ ok: true, text: "" })}>×</button>
        </div>
      )}

      <div style={s.filterRow}>
        {FILTERS.map((f) => (
          <button key={f.key}
            style={{ ...s.filterBtn, ...(status === f.key ? s.filterBtnActive : {}) }}
            onClick={() => setStatus(f.key)}>
            {f.label} <span style={s.count}>{counts[f.key] ?? 0}</span>
          </button>
        ))}
        <div style={{ marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button style={s.ghostBtn} onClick={handleScan} disabled={scanning}>
            {scanning ? "Scanning..." : "🔎 Scan DB"}
          </button>
          <button style={s.ghostBtn} onClick={exportCsv} disabled={!filtered.length}>⬇️ Export CSV</button>
          <button style={s.ghostBtn} onClick={load}>🔄 Refresh</button>
        </div>
      </div>

      <div style={s.searchBox}>
        <input style={{ ...s.input, marginBottom: 0, flex: 1 }} type="text"
          placeholder="🔍 Naam / Reg. No. / Phone / Course se search karein..."
          value={search} onChange={(e) => setSearch(e.target.value)} />
        {search && <button style={s.ghostBtn} onClick={() => setSearch("")}>Clear</button>}
      </div>

      {loading ? (
        <div style={s.centered}>⏳ Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={s.empty}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>{status === "pending" ? "🎉" : "📭"}</div>
          <p>
            {search
              ? "Is search se koi student nahi mila."
              : status === "pending"
                ? "Abhi koi student bina email ke nahi hai. Purane records check karne ke liye \"Scan DB\" dabayein."
                : "Is list me abhi kuch nahi hai."}
          </p>
        </div>
      ) : (
        <div style={s.tableWrapper}>
          <table style={s.table}>
            <thead>
              <tr>
                {["#", "Naam", "Reg. No.", "Phone", "Course", "Attempts", "Last Attempt", "Status / Email", "Actions"].map((h) => (
                  <th key={h} style={s.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((it, i) => {
                const digits = String(it.phone || "").replace(/\D/g, "");
                const wa     = digits.length === 10 ? `91${digits}` : digits;
                return (
                  <tr key={it._id}>
                    <td style={{ ...s.td, color: "#94a3b8", fontSize: 12 }}>{i + 1}</td>
                    <td style={s.td}><b>{it.name || "—"}</b></td>
                    <td style={s.td}><span style={s.regBadge}>{it.registrationNo}</span></td>
                    <td style={s.td}>
                      {it.phone ? (
                        <>
                          {it.phone}
                          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                            <a href={`tel:${digits}`} style={s.link}>📞 Call</a>
                            {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" style={s.link}>💬 WhatsApp</a>}
                          </div>
                        </>
                      ) : <span style={{ color: "#dc2626", fontSize: 12 }}>No phone</span>}
                    </td>
                    <td style={s.td}>
                      {(it.courses && it.courses.length > 1) ? it.courses.join(" / ") : (it.course || "—")}
                    </td>
                    <td style={s.td}>
                      {it.source === "scan" && !it.attempts
                        ? <span style={s.scanBadge}>DB scan</span>
                        : <span style={it.attempts > 2 ? s.hotBadge : undefined}>{it.attempts || 0}x</span>}
                    </td>
                    <td style={s.td}>{it.lastAttemptAt ? formatDate(it.lastAttemptAt) : "—"}</td>
                    <td style={s.td}>
                      {it.status === "resolved" ? (
                        <>
                          <span style={s.okBadge}>✅ {it.resolvedBy === "admin" ? "Admin" : "Student"}</span>
                          <div style={{ fontSize: 12, color: "#334155", marginTop: 4 }}>{it.email}</div>
                          <div style={{ fontSize: 11, color: "#94a3b8" }}>{formatDate(it.resolvedAt)}</div>
                        </>
                      ) : (
                        <span style={s.missBadge}>📭 Email missing</span>
                      )}
                    </td>
                    <td style={s.td}>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <button style={s.btnEdit} onClick={() => openEdit(it)}>
                          {it.status === "resolved" ? "✏️ Change email" : "✉️ Add email"}
                        </button>
                        <button style={s.btnRemove} onClick={() => handleRemove(it)}>🗑 Remove</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Add / change email modal ── */}
      {editing && (
        <div style={s.overlay} onClick={() => setEditing(null)}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <h3 style={s.modalTitle}>✉️ {editing.name || "Student"} ka email</h3>
            <div style={s.metaBox}>
              <div><b>Reg. No.:</b> {editing.registrationNo}</div>
              <div><b>Course:</b> {editing.course || "—"}</div>
            </div>

            <label style={s.label}>Email</label>
            <input style={s.input} type="email" placeholder="student@example.com" autoFocus
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              onKeyDown={(e) => { if (e.key === "Enter") handleSave(); }} />

            <label style={s.label}>Phone</label>
            <input style={s.input} placeholder="9876543210"
              value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />

            <p style={s.hint}>Ye email student ke master record me save hoga. Uske baad student Registration No. ya email se certificate request kar sakta hai.</p>

            {formErr && <div style={s.formErr}>{formErr}</div>}

            <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
              <button style={s.btnCancel} onClick={() => setEditing(null)}>Cancel</button>
              <button style={s.btnSave} onClick={handleSave} disabled={saving}>
                {saving ? "Saving..." : "💾 Save email"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function formatDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return String(d); }
}

const s = {
  intro: { fontSize: 13, color: "#475569", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 10, padding: "10px 14px", marginBottom: 16, lineHeight: 1.5 },
  banner: { borderRadius: 10, padding: "10px 14px", fontSize: 14, marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 },
  bannerOk: { background: "#d1fae5", border: "1px solid #6ee7b7", color: "#065f46" },
  bannerErr: { background: "#fef2f2", border: "1px solid #fecaca", color: "#991b1b" },
  bannerClose: { background: "none", border: "none", fontSize: 18, cursor: "pointer", fontWeight: 700, color: "inherit" },
  filterRow: { display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap", alignItems: "center" },
  filterBtn: { padding: "7px 14px", borderRadius: 20, border: "1.5px solid #e2e8f0", background: "#fff", color: "#475569", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 },
  filterBtnActive: { background: "#ff5421", color: "#fff", border: "1.5px solid #ff5421", fontWeight: 600 },
  count: { background: "rgba(0,0,0,0.08)", borderRadius: 10, padding: "0 7px", fontSize: 12, fontWeight: 700 },
  ghostBtn: { padding: "7px 14px", borderRadius: 8, border: "1.5px solid #e2e8f0", background: "#fff", color: "#475569", fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" },
  searchBox: { display: "flex", gap: 8, marginBottom: 16, background: "#fff", padding: "12px 14px", borderRadius: 10, border: "1px solid #e2e8f0" },
  input: { width: "100%", padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e2e8f0", fontSize: 15, marginBottom: 10, boxSizing: "border-box", outline: "none" },
  centered: { textAlign: "center", padding: 40, color: "#64748b", fontSize: 16 },
  empty: { textAlign: "center", padding: 40, color: "#94a3b8", fontSize: 15 },
  tableWrapper: { background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "auto" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 14 },
  th: { background: "#f8fafc", color: "#475569", fontWeight: 600, padding: "12px 14px", textAlign: "left", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" },
  td: { padding: "12px 14px", color: "#1e293b", borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
  regBadge: { background: "#f0fdf4", color: "#15803d", padding: "2px 8px", borderRadius: 6, fontSize: 12, fontWeight: 600, fontFamily: "monospace", whiteSpace: "nowrap" },
  link: { fontSize: 12, color: "#4338ca", textDecoration: "none", fontWeight: 600 },
  scanBadge: { background: "#f1f5f9", color: "#64748b", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600 },
  hotBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 20, fontSize: 12, fontWeight: 700 },
  missBadge: { background: "#fef9c3", color: "#854d0e", padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" },
  okBadge: { background: "#d1fae5", color: "#065f46", padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 },
  btnEdit: { background: "#e0e7ff", color: "#4338ca", border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" },
  btnRemove: { background: "#fee2e2", color: "#991b1b", border: "none", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" },
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 16 },
  modal: { background: "#fff", borderRadius: 14, padding: "26px 26px 22px", width: 420, maxWidth: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 12px 40px rgba(0,0,0,0.25)" },
  modalTitle: { fontSize: 18, fontWeight: 700, color: "#1e1b4b", margin: "0 0 14px", paddingBottom: 12, borderBottom: "1px solid #e2e8f0" },
  metaBox: { background: "#f8fafc", borderRadius: 8, padding: "10px 12px", fontSize: 13, color: "#334155", marginBottom: 12, lineHeight: 1.6 },
  label: { fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6, marginTop: 6, display: "block" },
  hint: { fontSize: 12, color: "#64748b", margin: "4px 0 0", lineHeight: 1.5 },
  formErr: { background: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", borderRadius: 8, padding: "8px 12px", fontSize: 13, marginTop: 10 },
  btnSave: { flex: 1, padding: "11px", background: "#ff5421", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer" },
  btnCancel: { flex: 1, padding: "11px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" },
};